import styled from "styled-components";

export const CardContainer = styled.div`
  position: relative;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background-color: ${({ theme }) => theme.bg.card};
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  padding: 14px;
  box-shadow: 0px 0.832px 4.159px 0px rgba(63, 65, 66, 0.2);
  box-sizing: border-box;
  gap: 14px;
  height: 100%;
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.input};
  padding-top: 7px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CardHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: start;
`;

export const CardParagraph = styled.p`
  margin: 0;
  color: #acacac;
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
`;

export const CardLabel = styled.span`
  padding: 5px 10px;
  font-size: 12px;
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  border-radius: 9999px;
  width: fit-content;
`;

export const CardArrowContainer = styled.div`
  position: absolute;
  bottom: 5px;
  right: 10px;
  opacity: 0.5;

  ${({ arrowOnTop = false }) =>
    arrowOnTop
      ? `
    bottom: 10px;
    right: 10px;
  `
      : `
    top: 20px;
    right: 10px;
  `}
`;

export const CardEmoji = styled.div`
  font-size: 28px;
  cursor: pointer;
`;
